const o=o=>{console.error(o)};export{o as errorHandler};